import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-cake-build-sizes',
  templateUrl: './ui-cake-build-sizes.component.html',
  styleUrls: ['./ui-cake-build-sizes.component.scss']
})
export class UiCakeBuildSizesComponent {
  @Input() sizes: any[];
  @Input() activeSize: any;
  @Input() currency = 'kr';
  @Input() discount: number;
  @Output() onSelect = new EventEmitter<any>();

  public isActiveSize(size) {
    if (!this.activeSize) {
      return false;
    }

    return this.activeSize.details.id === size.details.id;
  }
}
